// @flow
import React from 'react'
import './styles.scss'
import { EmojiReactions } from '../emojireactions'
import renderHTML from 'react-render-html'

export class FeatureStory extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      activeStoryLiked: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div className='ui vertical story segment' style={{ paddingTop: 0 }}>
        <div className='ui text container'>
          <div className='ta text'>
            <div className='illustration'>
              <img className='ui fluid image' src={this.props.image} />
            </div>
            <h4>{this.props.person}</h4>
            <h3>{this.props.title}</h3>
            <div>
              {renderHTML(this.props.children)}
              {this.props.isRealName && (
                <div className='note'>*Name geändert</div>
              )}
            </div>
          </div>

          <EmojiReactions
            storyID={this.props.storyID}
            articleID={this.props.articleID}
          />
        </div>
      </div>
    )
  }
}
